import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Opera',
  type: 'work',
  sections: {
    top: [
      // {
      //   id: 'text-viewer',
      //   type: 'text-viewer',
      //   options: {
      //     searchId: 'xml_text',
      //   },
      // },
        {
        id: 'parallel-text-viewer',
        type: 'parallel-text-viewer',
        options: {
          searchId: 'xml_text',
          grid: {
            panels: [0],
          },
          panels:[
            {
              id: "fonti",
              odd: "leopardi_antico_index",
              view: "div",
              title: "Fonti antiche",
            }
          ]
        },
      },
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
        title: 'resource#metadata',
      },
      // {
      //   id: 'collection-bibliography',
      //   type: 'collection',
      //   grid: 1,
      //   title: 'resource#collection_bibliography',
      //   options: {
      //     classes: 'mr-item-preview-bibliography',
      //     itemPreview: {
      //       limit: 9999,
      //       striptags: false,
      //     },
      //   },
      // },
    ],
  },
} as ConfigMurucaResourceLayout;
